import { createFileRoute } from '@tanstack/react-router';
import ComplianceRecordList from '@/components/features/compliance/components/compliance-record-list';

export const Route = createFileRoute('/_authenticated/compliance/loto-permits')({
  component: ComplianceRecordList,
});
